import { isArrayWithLength } from '../validators/validators';

import { ARTICLE_STATUSES } from '../../constants/products';

export function getShouldShowCompare(articleStatus) {
  return (
    !articleStatus ||
    articleStatus === ARTICLE_STATUSES.ACTIVE ||
    articleStatus === ARTICLE_STATUSES.DISCONTINUED ||
    articleStatus === ARTICLE_STATUSES.BACKORDER ||
    articleStatus === ARTICLE_STATUSES.TEMPORARILY_UNAVAILABLE
  );
}

export const getClubPromotion = (promotions, user) =>
  promotions?.find(
    promotion => promotion?.promotionConditionType === user?.clubMembership
  ) || promotions?.[0];

export const getClubPromotions = promotions => {
  const clubPromotions = [];

  if (isArrayWithLength(promotions)) {
    promotions?.forEach(
      promotion =>
        promotion?.promotionGroup === 'clubSavingsPromotionRuleGroup' &&
        clubPromotions.push(promotion)
    );
  }

  return clubPromotions;
};

export const getShowClubMembershipSignIn = (promotion, isLoggedIn, user) =>
  !isLoggedIn ||
  !user?.clubMembership ||
  user?.clubMembership !== promotion?.promotionConditionType;
